import * as IconMap from '@hagerty/icons';
export type IconType = keyof typeof IconMap;

export type IconSize =
  | 'default'
  | 'small'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge'
  | 'scale';

export type IconColor = 'dark' | 'white' | 'blue' | 'light-2';

export interface IconProps {
  /**
   * Icon to display. See `@hagerty/icons` for available icons or pass string for custom icon.
   */
  icon: IconType | string;

  /**
   * Sets the base size of the icon
   */
  size?: IconSize;

  /**
   * Sets the icon color
   */
  color?: IconColor;

  /**
   * Sets the className for the icon
   */
  className?: string;

  /**
   * Sets the data-testid for the icon
   */
  testId?: string;
}

/**
 * Determines if the props match IconProps. See also, isImage in Image.types
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isIcon = (props: IconProps | any): props is IconProps =>
  props && 'icon' in props;
